import { useEffect } from 'react';

export const useScrollTopByElementId = (id, ...deps) => {
  useEffect(() => {
    const el = document.getElementById(id);

    if (el) {
      el.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }, deps);
};



// WEBPACK FOOTER //
// ./src/hooks/useScrollTopByElementId.js